import React, { PropTypes } from 'react';
import Autosuggest from 'react-autosuggest';
import Toggle from 'material-ui/Toggle';

import { NitroTextField } from 'nitro-components';

import styled from 'styled-components';

const FormError = styled.div`
  position: relative;
  bottom: 0px;
  font-size: 12px;
  line-height: 12px;
  color: rgb(161, 52, 52);
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  margin-top: 5px;
`;

const AutoComplete = styled.div`
  .react-autosuggest__container {
    position: relative;
  }
  .react-autosuggest__input {
    width: 100%;
    height: 48px;
    padding: 10px 20px;
    font-family: ${props => props.theme.font.default};
    font-weight: 300;
    font-size: 14px;
    border: 1px solid ${props => props.theme.color.border};
    border-radius: 4px;
    color: ${props => props.theme.color.base2};
  }
  .react-autosuggest__input--focused {
    outline: none;
  }
  .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-autosuggest__suggestions-container {
    display: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    width: 100%;
    border: 1px solid ${props => props.theme.color.border};
    background-color: ${props => props.theme.color.white};
    font-family: ${props => props.theme.font.default};
    color: ${props => props.theme.color.base2};
    font-weight: 300;
    font-size: 14px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    border-top: none;
    max-height: 180px;
    overflow-y: auto;
    box-shadow: ${props => props.theme.boxShadow['3']};
    border-radius: 2px;
  }

  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
  }
`;

export const renderFormTextField = props => (
  <NitroTextField
    floatingLabelText={props.floatingLabelText}
    fullWidth={props.fullWidth}
    errorText={props.meta.touched && props.meta.error}
    {...props.input}
    {...props.customprops}
  />
);

renderFormTextField.propTypes = {
  floatingLabelText: PropTypes.string,
  fullWidth: PropTypes.bool,
  meta: PropTypes.object,
  input: PropTypes.array,
};

export const renderFormToggle = props => {
  let errorElement = null;
  if (props.meta.dirty && props.meta.error) {
    errorElement = <FormError>{props.meta.error}</FormError>;
  }
  return (
    <div>
      <Toggle
        label={props.label}
        checked={props.input.value ? true : false}
        onToggle={props.input.onChange}
        value={props.input.value}
      />
      {errorElement}
    </div>
  );
};

export const renderFormNumberField = props => {
  return (
    <NitroTextField
      floatingLabelText={props.floatingLabelText}
      fullWidth={props.fullWidth}
      errorText={props.meta.touched && props.meta.error}
      type="number"
      value={props.value || props.input.value}
      onChange={evt => {
        console.log('numeric field changed');
        props.input.onChange(parseFloat(evt.target.value));
      }}
    />
  );
};

export const renderFormAutoSuggest = props => {
  let errorElement = null;
  const inputProps = props.inputProps;
  const oldOnChange =
    inputProps && inputProps.onChange ? inputProps.onChange : () => {};
  if (props.meta.dirty && props.meta.error) {
    errorElement = <FormError>{props.meta.error}</FormError>;
  }
  inputProps.onChange = (evt, { newValue, method }) => {
    //if(newValue.trim()===''){
    props.input.onChange(null);
    //}

    oldOnChange(evt, { newValue, method });
  };

  return (
    <AutoComplete>
      <Autosuggest
        suggestions={props.suggestions}
        onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={props.onSuggestionsClearRequested}
        getSuggestionValue={props.getSuggestionValue}
        renderSuggestion={props.renderSuggestion}
        onSuggestionSelected={(evt, opt) => {
          props.input.onChange(opt.suggestion);
          if (props.onSuggestionSelected) {
            props.onSuggestionSelected(evt, opt);
          }
        }}
        inputProps={props.inputProps}
      />
      {errorElement}
    </AutoComplete>
  );
};



// WEBPACK FOOTER //
// ./src/utils/forms/FormFieldValidatonWrapper.js